module.exports = __webpack_public_path__ + "img/sb.5f98b526.svg";